import { render } from "./App.vue?vue&type=template&id=e47205ac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e47205ac&lang=css"
script.render = render

export default script